import { GoogleMap, MarkerF } from "@react-google-maps/api";
import Geocode from "react-geocode";

function MapForLocationSelect({ setMapData, mapData, callSearchBoxSelect }) {
  const coordsRaw = mapData?.coords;

  const coords = coordsRaw
    ? { lat: Number(coordsRaw.lat), lng: Number(coordsRaw.lng) }
    : null;

  const hasCoords =
    coords && Number.isFinite(coords.lat) && Number.isFinite(coords.lng);

  const onMarkerDragEnd = (event) => {
    const newLat = event.latLng.lat();
    const newLng = event.latLng.lng();

    Geocode.fromLatLng(newLat, newLng).then(
      (response) => {
        const results = response?.results || [];

        // safer address selection (your current indexing can throw)
        const newAddress =
          results.find((r) => r?.formatted_address)?.formatted_address ||
          "Unknown address";

        setMapData({ address: newAddress, coords: { lat: newLat, lng: newLng } });
        callSearchBoxSelect(newAddress, true);
      },
      (error) => console.error(error)
    );
  };

  if (!hasCoords) return null; // or a small placeholder div

  return (
    <GoogleMap
      options={{ gestureHandling: "greedy" }}
      zoom={16.5}
      center={coords}
      mapContainerClassName="map-container"
    >
      <MarkerF
        key={`${coords.lat},${coords.lng}`}   // forces refresh if coords change
        draggable
        position={coords}
        onDragEnd={onMarkerDragEnd}
      />
    </GoogleMap>
  );
}

export default MapForLocationSelect;